/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiRequestTicketStatus } from '../../models/api-request-ticket-status';
import { ApiResponseTicketStatus } from '../../models/api-response-ticket-status';

export interface CreateStatus$Params {
      body: ApiRequestTicketStatus
}

export function createStatus(http: HttpClient, rootUrl: string, params: CreateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketStatus>> {
  const rb = new RequestBuilder(rootUrl, createStatus.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTicketStatus>;
    })
  );
}

createStatus.PATH = '/v1/api/ui/status-ticket/create';
